import {faMoon, faSun} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

type Props = {
    darkMode: boolean
    toggleDarkMode: () => void
}

const DarkLightSwitch = (props: Props) => {
    return (
        <button onClick={()=>{props.toggleDarkMode()}} aria-label={"Toggle dark mode"}
                className={`flex h-8 w-16 cursor-pointer touch-manipulation items-center rounded-full px-1 transition-colors
                sm:h-7 sm:w-14 ${props.darkMode ? "bg-accent" : "bg-borderDark"}`}>
            <div className={"flex h-6 w-6 items-center justify-center rounded-full bg-white shadow " +
                    "transition-transform duration-200 " +
                    (props.darkMode ? "translate-x-8 sm:translate-x-7" : "translate-x-0")}>
                <FontAwesomeIcon size={"xs"} icon={props.darkMode ? faMoon : faSun}
                                 className={props.darkMode ? "text-accent" : "text-amber-400"}/>
            </div>
        </button>
    )
}

export default DarkLightSwitch
